import { get } from 'lodash-es'

class CouponUtils {

  static getAppliedManualCoupon(orderData) {
    // If a coupon is set up weird in BRT audit can return coupons as `null` instead of the expected array
    const coupons = get(orderData, 'coupons', []) || []
    return coupons.find(coupon => coupon.type === 'MANUAL' && coupon.applied)
  }

  static getAppliedDiscounts(orderData) {
    // If a coupon is set up weird in BRT audit can return coupons as `null` instead of the expected array
    const coupons = get(orderData, 'coupons') || []
    const lineItems = get(orderData, 'lineItems', [])
    const discounts = coupons.filter(coupon => coupon.category === 'DISCOUNT' && coupon.applied)

    // When the customer is getting a bonus card we add a $20 gift card line item and then apply a
    // $20 discount coupon to it. We don't want to show this bonus card coupon in the list of discounts
    // and the only way to identify it as a bonus card coupon is to check the line item it applies to.
    for (let i = discounts.length - 1; i >= 0; i -= 1) {
      discounts[i].couponEffects.forEach((effect) => {
        const item = lineItems.find(lineItem => lineItem.reiRefId === effect.lineItemRefId)
        if (get(item, 'giftCardDetails.promoGiftCard')) {
          // If it's a promo card remove from the array
          discounts.splice(i, 1)
        }
        return item
      })
    }

    return discounts
  }

  static getAppliedManualCouponName(orderData) {
    const appliedCoupon = this.getAppliedManualCoupon(orderData)
    return get(appliedCoupon, 'name', null)
  }

  static getAppliedManualCouponMessage(orderData) {
    const coupon = this.getAppliedManualCoupon(orderData)
    if (!coupon) return null
    const couponPrefix = `${coupon.name}: `

    // The default coupon messages from BRT are prefixed with `couponName: `, we don't want this to
    // display in the UI so we're going to first verify it is present then return an altered message
    if (coupon.message.indexOf(couponPrefix) === 0) {
      return coupon.message.substring(coupon.message.length, couponPrefix.length)
    }

    return coupon.message
  }

  static getAppliedManualCouponNameByItemId(orderData, itemId) {
    let appliedCoupon
    const manualCoupon = this.getAppliedManualCoupon(orderData)

    if (manualCoupon) {
      manualCoupon.couponEffects.forEach((effect) => {
        if (effect.lineItemRefId === itemId) appliedCoupon = manualCoupon.name
      })
    }

    return appliedCoupon
  }

  static getAutoCouponLabel(coupon) {
    const defaultMessage = new RegExp(`${coupon.name}: You saved \\$(\\d+\\.\\d{2}) on (\\d+) (item|items) with this offer\\.`)
    return defaultMessage.test(coupon.message) ? 'Promo applied' : coupon.message.replace(`${coupon.name}: `, '')
  }
}

export default CouponUtils
